import faviconBox from './faviconCard/faviconBox'
import faviconHeading from './faviconCard/faviconHeading'
import faviconSpecifications from './faviconCard/faviconSpecifications'
import stepByStep from './faviconCard/stepByStep'
import uploadFavicon from './faviconCard/uploadFavicon'
import modalDeleteFavicon from './faviconCard/modalDeleteFavicon'

export default {
  faviconBox,
  faviconHeading,
  faviconSpecifications,
  stepByStep,
  uploadFavicon,
  modalDeleteFavicon
}
